import { Checkbox } from 'components/ideal-core-ui'
import s from '../Opportunity.scss'

const Emails = ({ details, setOrganizationDetails }) => {
  return (
    <>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Email proposal sender when a proposal is approved
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.sendApprovalEmail}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.sendApprovalEmail = value.target.checked
            })
          }}
        />
        <p>
          If you use the internal review process for proposals, when a user sends a proposal out for
          review to their manager and the manager approves it, an email is sent back to the user to
          let him know the proposal was approved and is ready to be sent.
        </p>
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Send email to internal PMs when deal is won
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.wonDealEmail}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.wonDealEmail = value.target.checked
            })
          }}
        />
        <p>
          If you use the internal team on opportunities, when an opportunity is marked as Won, the
          Project Managers on the Internal Team of that opportunity will receive an email announcing
          the won project.
        </p>
      </div>
      <div className={s.settingsItem}>
        <h5 style={{ marginRight: '15px', display: 'inline-block' }}>
          Send email to opportunity manager & internal team members when an opportunity is assigned
          to them
        </h5>
        <Checkbox
          size="md"
          isChecked={details.dealSettings?.teamAddEmail}
          triggerCheckbox={value => {
            setOrganizationDetails(state => {
              state.dealSettings.teamAddEmail = value.target.checked
            })
          }}
        />
        <p>
          When this setting is checked, an email is sent out to a user when they&apos;re added on
          Internal Team of an opportunity, or if they are assigned as opportunity manager.
        </p>
      </div>
    </>
  )
}

export default Emails
